import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_result = _resolveComponent("el-result")!

  return (_openBlock(), _createBlock(_component_el_result, {
    icon: "success",
    title: "初始化升级成功",
    "sub-title": `将在${$setup.second}秒后进入默认页面`
  }, {
    extra: _withCtx(() => [
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: $setup.go_default_page
      }, {
        default: _withCtx(() => [
          _createTextVNode("直接进入")
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["sub-title"]))
}